<app-page-header
  class="header"
  [inside]="true"
  [backSwipe]="backSwipeConfig"
  (backButtonClick)="back.emit()"
/>

<div class="content">
  <div class="info">
    <span class="title">Want to earn free Bowling $$$? Become a member today!!!</span>
    <span class="text">Over $50 in Annual Rewards</span>
    <div class="items">
      <div class="item">💸&nbsp;<span class="green">$5&ensp;</span> Just for Singing Up</div>
      <div class="item">🎂&nbsp;Birthday Bonus –&ensp;<span class="green">$5</span></div>
      <div class="item">💚&nbsp;Anniversary –&ensp;<span class="green">$10</span></div>
      <div class="item big">🎄&nbsp;Christmas,&ensp;🍁&ensp;Thanksgiving,&ensp;🇨🇦&ensp;Canada Day...
        <span class="green">🎉&ensp;10+ Holidays = More Rewards!</span>
      </div>
    </div>
    <span class="fee">No Fee</span>
  </div>
  <div class="contacts">
    <span class="title">Three ways to Sign Up!</span>
      <div class="details">
        <div class="detail">
          <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.7 16c0-5 0-7.5 1.5-9.1 1.6-1.6 4.1-1.6 9.1-1.6h5.4c5 0 7.5 0 9 1.6 1.6 1.6 1.6 4 1.6 9.1 0 5 0 7.5-1.5 9.1-1.6 1.6-4.1 1.6-9.1 1.6h-5.4c-5 0-7.5 0-9-1.6-1.6-1.6-1.6-4-1.6-9.1Z"
                  stroke="#6DE951" stroke-width="2"
            />
            <path d="m8 10.7 2.9 2.4c2.4 2 3.7 3 5.1 3 1.4 0 2.7-1 5.1-3l2.9-2.4"
                  stroke="#6DE951" stroke-width="2" stroke-linecap="round"
            />
          </svg>
          Text GB to <span class="green">1-888-210-5701</span>
        </div>
        <div class="detail">
          <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.4 18.7c-2-2-1.8-5.5.4-7.7l6.5-6.5c2.2-2.3 5.6-2.4 7.6-.4s1.9 5.4-.4 7.7L24.3 15"
                  stroke="#6DE951" stroke-width="2" stroke-linecap="round"
            />
            <path d="M18.6 13.3c2 2 1.8 5.5-.4 7.7L15 24.3l-3.3 3.2c-2.2 2.3-5.6 2.4-7.6.4s-1.9-5.4.4-7.7L7.7 17"
                  stroke="#6DE951" stroke-width="2" stroke-linecap="round"
            />
          </svg>
          Go to <span class="green">www.georgianbowl.com</span>
        </div>
        <div class="detail">
          <svg width="32" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.7 11.3c7.3-8 19.3-8 26.6 0M7.1 16.1A12 12 0 0 1 25 16m-13.3 4.8a6 6 0 0 1 8.8 0"
                  stroke="#6DE951" stroke-width="2" stroke-linecap="round"/>
            <circle cx="16" cy="25.1" r="1" fill="#6DE951" stroke="#6DE951" stroke-width="2"/>
          </svg>
          Sign into <span class="green">!GB Free WiFI</span>
        </div>
      </div>
  </div>
</div>
